<template>
  <div class="q-age main-color">
    <label class="label-2cols q-label" v-html="question.q"></label>
      <md-field class="q-age-dropdown-container">
        <md-select name="optionsAnswers" id="optionsAnswers" placeholder="Seleccionar" :disabled="readOnly" v-model="answer" @md-selected="emitValueAge" >
          <md-option v-for="n in range(question.min, question.max).slice().reverse()" :key="n" :value="n">{{ n }}</md-option>
        </md-select>
      </md-field>
  </div>
</template>

<script>
export default {
  name: "age-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: String,
      default: ""
    },
    readOnly:{
      type:Boolean,
      default: false
    }
  },
  data: function() {
    return {
      answer: this.answerProp
    };
  },
  methods: {
    range: function(start, end) {
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },
    emitValueAge: function() {
      //console.log(this.answer);
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    }
  },
  created: function() {
    this.resultId = this.$route.query.r;
  }
};
</script>
